var React = require('react');

function SocialIconFacebook (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_2","data-name":"Layer 2"},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("path",{"d":"M484.81,66c231.39,0,419,187.58,419,419s-187.58,419-419,419-419-187.58-419-419,187.58-419,419-419m0-66C216.91.15-.15,217.45,0,485.35A485.07,485.07,0,0,0,296,931.8c247.5,102.54,531.27-15,633.81-262.48,101.52-245-12.61-526.19-256.2-631.15A482,482,0,0,0,484.81,0Z","key":0}),React.createElement("path",{"d":"M404.52,778.37V483.47H342.25V384.34h62.27V312.48s-16.16-120,120.37-120.36l88.82-.49.33,103.3-70.83.11a20.55,20.55,0,0,0-20.51,20.28v68.23l91,.43-8.31,99.49H521.81v294.9Z","key":1})])));
}

SocialIconFacebook.defaultProps = {"viewBox":"0 0 966.88 968.87"};

module.exports = SocialIconFacebook;

SocialIconFacebook.default = SocialIconFacebook;
